/* eslint-disable */
import { IHttpClient } from '../api';
import { Smartwatch } from "@/domain/smartwatch";
import {AppConfig} from "@/utils/enums";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface SmartwatchResponse {
    smartwatches: Smartwatch[];
}

export const SmartwatchApi = (http: IHttpClient) => ({

    fetchAllSmartwatches: () =>
        http.get<SmartwatchResponse>(apiUrl + AppConfig.API_SMARTWATCHES_URL)
            .then(response => ({
                smartwatches: response.data
            })),
    fetchAllAvailableSmartwatches: () =>
        http.get<SmartwatchResponse>(apiUrl + AppConfig.API_SMARTWATCHES_URL + '/available')
            .then(response => ({
                smartwatches: response.data
            })),
    saveNewSmartwatch: (newSmartwatch: Smartwatch) =>
        http.post<Smartwatch>(apiUrl + AppConfig.API_SMARTWATCHES_URL, newSmartwatch)
            .catch(error => {
                return error;
            }),
    updateSmartwatch: (updatedSmartwatch: Smartwatch) =>
        http.put<Smartwatch>(apiUrl + AppConfig.API_SMARTWATCHES_URL, updatedSmartwatch)
            .then(data => {
                return data;
            })
            .catch(error => {
                return error;
            }),
    deleteSmartwatch: (smartwatchId: number) =>
    http.delete<number>(apiUrl + AppConfig.API_SMARTWATCHES_URL + '/' + smartwatchId)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
});
